<template>
  <el-dialog :title="$t('1146')" :visible.sync="visible" :before-close="close" width="576px">
    <el-form :model="form" :rules="rules" ref="form" label-width="160px">
      <!-- 方案名称 -->
      <el-form-item :label="$t('1145')" prop="name">
        <el-input v-model="form.name" :placeholder="$t('1145')" max="50"></el-input>
      </el-form-item>
      <!-- 结算类型 -->
      <el-form-item :label="$t('33')" prop="type">
        <el-select v-model="form.type" :placeholder="$t('796')">
          <el-option :label="item.txt" :value="item.type" v-for="(item, index) in typeList" :key="index"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="close">{{ $t('66') }}</el-button>
      <el-button size="small" type="primary" @click="handlerChangeVisible">{{ $t('payroll_salary_11') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Vue from 'vue'
const $t = Vue.prototype.$t
// 规则
const rules = {
  name: [{ required: true, message: $t('1149'), trigger: 'blur' }],
  type: [{ required: true, message: $t('796'), trigger: 'blur' }]
}
const form = () => ({
  name: '',
  type: ''
})
export default {
  props: {
    visible: {
      default: true
    },
    typeList: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    visible(v) {
      if (!v) this.form = form()
    }
  },
  data() {
    return {
      form: form(),
      rules
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
    // 隐藏当前弹窗
    handlerChangeVisible() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$emit('handlerCreate', this.form)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-select {
  width: 312px;
}
/deep/ .el-input {
  max-width: 312px;
}
</style>
>
